<template>
  <div class="form-setting-modal">
    <div class="setting-modal-wrapper">
      <div class="btn-close" @click="onCloseModal"></div>
      <div class="header">
        <h2>Einstellungen</h2>
      </div>
      <div class="content fancy-scroll" @scroll.passive="showScrollbar">
        <form>
          <div v-if="isVueBasedFormBuilder">
            <FormLayoutSetting
              :task="this.task"
              :process="this.process"
              :currentScreen="currentScreen"
              :isUserHasAccess="isUserHasAccess"
              @onChangeCustomSpacingScreen="onChangeCustomSpacingScreen"
            />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { getIsVueBasedFormBuilder } from '@/utils/helpers';
import FormLayoutSetting from './FormBuilderLayoutSetting.vue';
export default {
  name: 'FormSettingModal',

  props: {
    process: {
      type: Object,
      default: () => {},
    },
    task: {
      type: Object,
      default: () => {},
    },
    currentScreen: {
      type: String,
      default: 'desktop',
    },
    isUserHasAccess: { type: Boolean, default: true },
  },
  methods: {
    showScrollbar(event) {
      event.target.classList.add('show-scrollbar');
      debouncer(
        () => {
          event.target.classList.remove('show-scrollbar');
        },
        300,
        this,
        'removeScrollClass'
      );
    },
    onCloseModal() {
      this.$emit('close');
    },
    onChangeCustomSpacingScreen(screenName) {
      this.$emit('onChangeCustomSpacingScreen', screenName);
    },
  },

  computed: {
    isVueBasedFormBuilder() {
      return getIsVueBasedFormBuilder(this.process);
    },
  },

  components: {
    FormLayoutSetting,
  },
};
</script>

<style scoped>
.form-setting-modal {
  height: 100%;
  width: 425px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.form-setting-modal .setting-modal-wrapper {
  text-align: left;
  padding: 40px 0;
  border-left: 1px solid #dee3e9;
  border-radius: 0px 19px 19px 0px;
  background: #ffffff;
  display: block;
  text-align: left;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  height: 100%;
  width: 100%;
  position: relative;
}
.form-setting-modal .setting-modal-wrapper .btn-close {
  position: absolute;
  top: 32px;
  right: 36px;
  background-image: url(../../assets/img/work-flow-icons/close.svg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 14px;
  height: 14px;
  cursor: pointer;
}
.form-setting-modal .setting-modal-wrapper .btn-close:hover {
  opacity: 0.8;
}

.form-setting-modal .header {
  padding: 20px 40px;
}

.form-setting-modal .content {
  height: calc(100dvh - 245px);
  overflow: auto;
  padding: 0 40px;
}
.form-setting-modal .header h2 {
  margin: 0;
  text-align: center;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
}

.form-setting-modal .switch-group {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
</style>
